import { NgModule } from '@angular/core';
import { WikiComponent } from './wiki.component';
import { WikiService } from './wiki.service';
import { WikiRoutingModule } from './wiki-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  imports: [WikiRoutingModule, SharedModule, MatTabsModule, MatPaginatorModule],
  declarations: [WikiComponent],
  exports: [WikiComponent],
  providers: [WikiService]
})
export class WikiModule { }
